import { render, staticRenderFns } from "./ProposalDetails.vue?vue&type=template&id=1aeb44b8&scoped=true"
import script from "./ProposalDetails.vue?vue&type=script&lang=js"
export * from "./ProposalDetails.vue?vue&type=script&lang=js"
import style0 from "./ProposalDetails.vue?vue&type=style&index=0&id=1aeb44b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeb44b8",
  null
  
)

export default component.exports